/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Purchase_3Inputs */

const en_flow_purchase_3 = /** @type {(inputs: Flow_Purchase_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The warehouse receives the goods.`)
};

/**
* | output |
* | --- |
* | "The warehouse receives the goods." |
*
* @param {Flow_Purchase_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_purchase_3 = /** @type {((inputs?: Flow_Purchase_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Purchase_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_purchase_3(inputs)
});